module.exports = __webpack_public_path__ + "img/imgs4.829b1e52.png";